import { useEffect, useRef } from "react";
import type { Team } from "@sportsos/engine";
import { api } from "../api.ts";

/** Often enough that a player who scans the QR shows up while the captain is still looking. */
export const SQUAD_POLL_MS = 4000;

/**
 * Re-read a saved team every few seconds while `active`, and hand each copy to `onTeam`.
 *
 * Joining by QR happens on someone else's phone, so nothing on this screen hears about it.
 * Polling only while the invite is open keeps the cost to the minutes a captain is actually
 * waiting for people to scan. A failed read is ignored: the next tick tries again.
 */
export function useSquadPoll(teamId: string | null, active: boolean, onTeam: (team: Team) => void): void {
  const latest = useRef(onTeam);
  latest.current = onTeam;

  useEffect(() => {
    if (!active || teamId === null) return;
    let live = true;
    const timer = window.setInterval(() => {
      void api
        .listTeams()
        .then((res) => {
          const found = res.teams.find((team) => team.id === teamId);
          if (live && found !== undefined) latest.current(found);
        })
        .catch(() => undefined);
    }, SQUAD_POLL_MS);
    return () => {
      live = false;
      window.clearInterval(timer);
    };
  }, [teamId, active]);
}
